
export const LOCALE_TEXT_ITA = {

    noRowsLabel: 'Nessuna riga',
    noResultsOverlayLabel: 'Nessun risultato.',
    errorOverlayDefaultLabel: 'Errore.',


    toolbarDensity: 'Densità',
    toolbarDensityLabel: 'Densità',
    toolbarDensityCompact: 'Densità',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',


    toolbarColumns: 'Colonne',
    toolbarColumnsLabel: 'Seleziona colonne',


    toolbarFilters: 'Filtri',
    toolbarFiltersLabel: 'Mostra filtri',
    toolbarFiltersTooltipHide: 'Nascondi filtri',
    toolbarFiltersTooltipShow: 'Mostra filtri',
    toolbarFiltersTooltipActive: (count) =>
        count !== 1 ? `${count} filtri attivi` : `${count} filtro attivo`,


    toolbarQuickFilterPlaceholder: 'Ricerca…',
    toolbarQuickFilterLabel: 'Cerca',
    toolbarQuickFilterDeleteIconLabel: 'Cancella',


    toolbarExport: 'Esporta',
    toolbarExportLabel: 'Esporta',
    toolbarExportCSV: 'Download come CSV',
    toolbarExportPrint: 'Stampa',
    toolbarExportExcel: 'Download come Excel',


    columnsPanelTextFieldLabel: 'Trova colonna',
    columnsPanelTextFieldPlaceholder: 'Titolo Colonna',
    columnsPanelDragIconLabel: 'Riordina colonna',
    columnsPanelShowAllButton: 'Mostra Tutto',
    columnsPanelHideAllButton: 'Cancella Tutto',


    filterPanelAddFilter: 'Aggiungi Filtro',
    filterPanelDeleteIconLabel: 'Cancella',
    filterPanelLinkOperator: 'Operatore Logico',
    filterPanelOperators: 'Operatore', // TODO v6: rename to filterPanelOperator
    filterPanelOperatorAnd: 'E',
    filterPanelOperatorOr: 'O',
    filterPanelColumns: 'Colonne',
    filterPanelInputLabel: 'Valore',
    filterPanelInputPlaceholder: 'Filtra valore',


    filterOperatorContains: 'contiene',
    filterOperatorEquals: 'uguale a',
    filterOperatorStartsWith: 'inizia con',
    filterOperatorEndsWith: 'finisce con',
    filterOperatorIs: 'è',
    filterOperatorNot: 'non è',
    filterOperatorAfter: 'è dopo',
    filterOperatorOnOrAfter: 'è in o dopo',
    filterOperatorBefore: 'è prima',
    filterOperatorOnOrBefore: 'è prima o dopo',
    filterOperatorIsEmpty: 'è vuoto',
    filterOperatorIsNotEmpty: 'non è vuoto',
    filterOperatorIsAnyOf: 'qualsiasi tra',


    filterValueAny: 'qualsiasi',
    filterValueTrue: 'vero',
    filterValueFalse: 'falseo',


    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Mostra Colonne',
    columnMenuFilter: 'Filtra',
    columnMenuHideColumn: 'Nascondi',
    columnMenuUnsort: 'Elimina ordine',
    columnMenuSortAsc: 'Ordina ASC',
    columnMenuSortDesc: 'Ordina DESC',


    columnHeaderFiltersTooltipActive: (count) =>
        count !== 1 ? `${count} filtri attivi` : `${count} filtro attivo`,
    columnHeaderFiltersLabel: 'Mostra filtri',
    columnHeaderSortIconLabel: 'Ordina',


    footerRowSelected: (count) =>
        count !== 1
            ? `${count.toLocaleString()} righe selezionate`
            : `${count.toLocaleString()} righe selezionate`,


    footerTotalRows: 'Righe totali:',


    footerTotalVisibleRows: (visibleCount, totalCount) =>
        `${visibleCount.toLocaleString()} di ${totalCount.toLocaleString()}`,


    checkboxSelectionHeaderName: 'Selezione Checkbox',
    checkboxSelectionSelectAllRows: 'Seleziona tutte le righe',
    checkboxSelectionUnselectAllRows: 'Deseleziona tutte le righe',
    checkboxSelectionSelectRow: 'Seleziona riga',
    checkboxSelectionUnselectRow: 'Deseleziona riga',


    booleanCellTrueLabel: 'sì',
    booleanCellFalseLabel: 'no',


    actionsCellMore: 'più',


    pinToLeft: 'Fissa a sx',
    pinToRight: 'Fissa a dx',
    unpin: 'rimuovi',


    treeDataGroupingHeaderName: 'Gruppo',
    treeDataExpand: 'mostra dettagli',
    treeDataCollapse: 'nascondi dettagli',


    groupingColumnHeaderName: 'Gruppo',
    groupColumn: (name) => `Raggruppa per ${name}`,
    unGroupColumn: (name) => `Cancella raggruppamento per ${name}`,


    detailPanelToggle: 'Tasto pannello dettagli',
    expandDetailPanel: 'Espandi',
    collapseDetailPanel: 'Chiudi',


    MuiTablePagination: {},


    rowReorderingHeaderName: 'Riordina righe',


    aggregationMenuItemHeader: 'Aggrega',
    aggregationFunctionLabelSum: 'somma',
    aggregationFunctionLabelAvg: 'media',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'dimensioni',
};